var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1274_3401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90074 4.69506H9.98121C11.2044 4.69506 11.816 4.69506 12.2553 4.98862C12.4456 5.1157 12.6088 5.279 12.7359 5.4692C13.0295 5.90854 13.0295 6.52014 13.0295 7.74334C13.0295 9.78203 13.0295 10.8013 12.5402 11.5336C12.3284 11.8506 12.0562 12.1228 11.7393 12.3345C11.007 12.8238 9.98771 12.8238 7.94902 12.8238H7.22324C4.48615 12.8238 3.1176 12.8238 2.2673 11.9735C1.41699 11.1232 1.41699 9.75462 1.41699 7.01756V5.24333C1.41699 4.18864 1.41699 3.66129 1.63782 3.26559C1.79522 2.98353 2.02797 2.75079 2.31003 2.59338C2.70572 2.37256 3.23307 2.37256 4.28776 2.37256C4.96346 2.37256 5.30132 2.37256 5.59706 2.48346C6.27229 2.73668 6.55076 3.35009 6.85547 3.95948L7.22324 4.69506",
    stroke: "#61646F",
    strokeWidth: 0.870937,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1274_3401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.935,
    height: 13.935,
    fill: "white",
    transform: "translate(0.256836 0.630615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.86ab1dc85f4cd3518bdf851dfa89ded5.svg";
export { ForwardRef as ReactComponent };